import { atom } from 'jotai';
import { useAtomValue, useSetAtom } from 'jotai/index';
import { selectAtom } from 'jotai/utils';

export interface Payload {
  sequenceId: string;
  sequenceTitle: string;
}

const payloadAtom = atom<Payload | undefined>(undefined);

const isOpenAtom = selectAtom(payloadAtom, p => !!p);
export const useIsOpenShareSequenceModal = () => useAtomValue(isOpenAtom);

const closeModalAtom = atom(null, (_, set) => set(payloadAtom, undefined));
export const useCloseShareSequenceModal = () => useSetAtom(closeModalAtom);

export const useOpenShareSequenceModal = () => useSetAtom(payloadAtom);

export const useGetShareSequenceModalPayload = () => useAtomValue(payloadAtom);
